import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { X, Plus } from "lucide-react";

const TagInput = ({ tags = [], onChange, suggestions = [], placeholder = "Add tag..." }) => {
  const [input, setInput] = useState("");

  const addTag = (name) => {
    const trimmed = name.trim().toLowerCase();
    if (!trimmed || tags.includes(trimmed)) return;
    onChange([...tags, trimmed]);
    setInput("");
  };

  const removeTag = (name) => onChange(tags.filter((t) => t !== name));

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag(input);
    }
  };

  const filtered = input
    ? suggestions.filter((s) => s.toLowerCase().includes(input.toLowerCase()) && !tags.includes(s.toLowerCase()))
    : [];

  return (
    <div>
      {tags.length > 0 && (
        <div className="d-flex flex-wrap gap-1 mb-2">
          {tags.map((t) => (
            <span key={t} className="plm-tag" style={{ cursor: "default" }}>
              {t}
              <X size={12} role="button" onClick={() => removeTag(t)} style={{ cursor: "pointer", opacity: 0.6 }} />
            </span>
          ))}
        </div>
      )}
      <InputGroup size="sm">
        <Form.Control
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          list="tag-suggestions"
          style={{ borderRadius: "6px 0 0 6px" }}
        />
        <datalist id="tag-suggestions">
          {filtered.map((s) => (
            <option key={s} value={s} />
          ))}
        </datalist>
        <InputGroup.Text
          role="button"
          onClick={() => addTag(input)}
          style={{ cursor: "pointer", borderRadius: "0 6px 6px 0" }}
        >
          <Plus size={14} />
        </InputGroup.Text>
      </InputGroup>
    </div>
  );
};

export default TagInput;
